import React, { FC } from "react";
import { Asset, Entry } from "contentful";
import BaseCollectionTile from "./BaseCollectionTile";
import useBrand from "../../hooks/useBrand";

interface CustomCollectionTileProps extends Entry {
  id: string,
  fields: {
    description?: string;
    hoverAsset?: Asset;
    imageAsset?: Asset;
    title: string;
    url: string;
    tileType: string;
  };
}

const CustomCollectionTile: FC<CustomCollectionTileProps> = ({ id, fields: {
  description,
  hoverAsset,
  imageAsset,
  title,
  url,
  tileType,
}}) => {
  const brand = useBrand();

  return (
    <BaseCollectionTile
      componentId={id}
      description={description}
      hoverImageUrl={hoverAsset?.fields?.file?.url as string}
      href={url}
      imageUrl={imageAsset?.fields.file?.url as string}
      title={title}
      tileType={tileType}
      brand={brand}
    />
  );
};

export default CustomCollectionTile;